"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var modules = require("./modules");
var apiModules = modules;
exports.default = (function (axios) {
    var returnFns = {};
    Object.keys(apiModules).forEach(function (module) {
        var moduleFn = apiModules[module](axios);
        Object.keys(moduleFn).forEach(function (fnName) {
            returnFns[fnName] = moduleFn[fnName];
        });
    });
    return returnFns;
});
